import { faUserCog } from '@fortawesome/pro-solid-svg-icons';
import { NavbarTopIcon } from '@sokigo-sbwebb/default-components';
import { useState } from 'react';
import UserSettingsModal from '../../features/user-settings/UserSettingsModal';

function UserSettings({ expanded }: { expanded: boolean }) {
  const [show, setShow] = useState(false);

  return (
    <>
      {expanded ? (
        <div style={{ height: 40 }}>
          <NavbarTopIcon
            block
            title="Personliga inställningar"
            expanded={expanded}
            icon={faUserCog}
            onClick={() => setShow(true)}
            aria-label="Personliga inställningar"
          />
        </div>
      ) : (
        <NavbarTopIcon
          title="Personliga inställningar"
          expanded={expanded}
          icon={faUserCog}
          onClick={() => setShow(true)}
          aria-label="Personliga inställningar"
        />
      )}
      {show && <UserSettingsModal onClose={() => setShow(false)} />}
    </>
  );
}

export default UserSettings;
